/**
 * Resolve the public property-page floor plan from composed wire data.
 *
 * @param {object[]} floors
 * @param {string|null|undefined} publicPlanSiteFloorId
 * @returns {object|null}
 */
export function pickPublicFloorPlan(floors, publicPlanSiteFloorId) {
  const list = Array.isArray(floors) ? [...floors] : [];
  if (!list.length) return null;

  if (publicPlanSiteFloorId) {
    const id = String(publicPlanSiteFloorId);
    const match = list.find((f) => String(f.id || f._id) === id);
    if (match) return match;
  }

  if (list.length === 1) return list[0];

  const withPlan = list.find((f) => (f.planImage || '').trim());
  return withPlan || list[0];
}

/**
 * @param {object|null|undefined} floor
 * @returns {boolean}
 */
export function shouldShowPublicFloorPlan(floor) {
  if (!floor || !(floor.planImage || '').trim()) return false;
  const rooms = Array.isArray(floor.rooms) ? floor.rooms : [];
  return rooms.length > 0;
}
